import styles from "./HeroBlock.module.scss";
import type { FC, ReactNode, ImgHTMLAttributes } from "react";
import { SliceBorder, Title } from "../../../shared/ui";
import { borderData } from "../const/HeroBlock.data";
import { generateMediaQuery } from "../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../shared/constants/media";
import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";

interface HeroBlockProps {
    title: ReactNode;
    imageAttributes: ImgHTMLAttributes<HTMLImageElement>;
    children?: ReactNode;
}

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md);

export const HeroBlock: FC<HeroBlockProps> = ({ title, children, imageAttributes }) => {
    const isMobile = useMediaQuery(mediaQuery);

    return (
        <section className={styles.wrapper}>
            <SliceBorder sizeRadius={isMobile ? 12 : 25} multiplierInside={1} border={borderData}>
                <Title className={styles.title} level={1}>
                    {title}
                </Title>
            </SliceBorder>
            <img className={styles.img} alt="background" {...imageAttributes} />
            {children}
        </section>
    );
};
